import { Link } from "react-router-dom";

export function Brand({ light = false, className = "" }) {
  const dot = light ? "bg-white" : "bg-[#0A0A0F]";
  const text = light ? "text-white" : "text-[#0A0A0F]";
  return (
    <Link to="/" className={`group inline-flex items-center gap-2.5 font-display font-black tracking-tight ${text} ${className}`}>
      <span className="relative flex items-center">
        <span className={`block w-2.5 h-2.5 ${dot} transition-transform duration-300 group-hover:rotate-45`} />
      </span>
      <span className="text-lg">LeadsB2B</span>
    </Link>
  );
}
